import { mk_query, mk_rel_query, FilterBuilderBoolean, FilterBuilderNumber, FilterBuilderString, FilterBuilderCollection, FilterBuilderDate, parseBoolean, parseNumber, parseDate, parseCollection, parseEntity, parseNullNumber, parseNullString, OrderByProp } from "typescript-odata-client";
const mk_prefix = (id, prefix)=>prefix ? prefix + '/' + id : id;
export const ActivityQuery = (uri)=>mk_query(FilterBuilderActivity(), ActivityRelationBuilder, uri != undefined ? uri + 'Activity' : 'http://localhost:5000/odata/Activity', ActivityParser, ActivityOrderBy(""));
export const Activity_ActivityEditionNQuery = (uri)=>mk_query(FilterBuilderActivity_ActivityEditionN(), Activity_ActivityEditionNRelationBuilder, uri != undefined ? uri + 'Activity_ActivityEditionN' : 'http://localhost:5000/odata/Activity_ActivityEditionN', Activity_ActivityEditionNParser, Activity_ActivityEditionNOrderBy(""));
export const Activity_ActivityEditionScheduleQuery = (uri)=>mk_query(FilterBuilderActivity_ActivityEditionSchedule(), Activity_ActivityEditionScheduleRelationBuilder, uri != undefined ? uri + 'Activity_ActivityEditionSchedule' : 'http://localhost:5000/odata/Activity_ActivityEditionSchedule', Activity_ActivityEditionScheduleParser, Activity_ActivityEditionScheduleOrderBy(""));
export const Activity_ArchivedActivityEditionNQuery = (uri)=>mk_query(FilterBuilderActivity_ArchivedActivityEditionN(), Activity_ArchivedActivityEditionNRelationBuilder, uri != undefined ? uri + 'Activity_ArchivedActivityEditionN' : 'http://localhost:5000/odata/Activity_ArchivedActivityEditionN', Activity_ArchivedActivityEditionNParser, Activity_ArchivedActivityEditionNOrderBy(""));
export const ActivityClusterQuery = (uri)=>mk_query(FilterBuilderActivityCluster(), ActivityClusterRelationBuilder, uri != undefined ? uri + 'ActivityCluster' : 'http://localhost:5000/odata/ActivityCluster', ActivityClusterParser, ActivityClusterOrderBy(""));
export const ActivityCluster_ActivityQuery = (uri)=>mk_query(FilterBuilderActivityCluster_Activity(), ActivityCluster_ActivityRelationBuilder, uri != undefined ? uri + 'ActivityCluster_Activity' : 'http://localhost:5000/odata/ActivityCluster_Activity', ActivityCluster_ActivityParser, ActivityCluster_ActivityOrderBy(""));
export const ActivityEditionNQuery = (uri)=>mk_query(FilterBuilderActivityEditionN(), ActivityEditionNRelationBuilder, uri != undefined ? uri + 'ActivityEditionN' : 'http://localhost:5000/odata/ActivityEditionN', ActivityEditionNParser, ActivityEditionNOrderBy(""));
export const ActivityEditionN_ActivityEditionScheduleQuery = (uri)=>mk_query(FilterBuilderActivityEditionN_ActivityEditionSchedule(), ActivityEditionN_ActivityEditionScheduleRelationBuilder, uri != undefined ? uri + 'ActivityEditionN_ActivityEditionSchedule' : 'http://localhost:5000/odata/ActivityEditionN_ActivityEditionSchedule', ActivityEditionN_ActivityEditionScheduleParser, ActivityEditionN_ActivityEditionScheduleOrderBy(""));
export const ActivityEditionN_ActivityEventQuery = (uri)=>mk_query(FilterBuilderActivityEditionN_ActivityEvent(), ActivityEditionN_ActivityEventRelationBuilder, uri != undefined ? uri + 'ActivityEditionN_ActivityEvent' : 'http://localhost:5000/odata/ActivityEditionN_ActivityEvent', ActivityEditionN_ActivityEventParser, ActivityEditionN_ActivityEventOrderBy(""));
export const ActivityEditionN_BookQuery = (uri)=>mk_query(FilterBuilderActivityEditionN_Book(), ActivityEditionN_BookRelationBuilder, uri != undefined ? uri + 'ActivityEditionN_Book' : 'http://localhost:5000/odata/ActivityEditionN_Book', ActivityEditionN_BookParser, ActivityEditionN_BookOrderBy(""));
export const ActivityEditionScheduleQuery = (uri)=>mk_query(FilterBuilderActivityEditionSchedule(), ActivityEditionScheduleRelationBuilder, uri != undefined ? uri + 'ActivityEditionSchedule' : 'http://localhost:5000/odata/ActivityEditionSchedule', ActivityEditionScheduleParser, ActivityEditionScheduleOrderBy(""));
export const ActivityEventQuery = (uri)=>mk_query(FilterBuilderActivityEvent(), ActivityEventRelationBuilder, uri != undefined ? uri + 'ActivityEvent' : 'http://localhost:5000/odata/ActivityEvent', ActivityEventParser, ActivityEventOrderBy(""));
export const AdminQuery = (uri)=>mk_query(FilterBuilderAdmin(), AdminRelationBuilder, uri != undefined ? uri + 'Admin' : 'http://localhost:5000/odata/Admin', AdminParser, AdminOrderBy(""));
export const ArchivedActivityEditionNQuery = (uri)=>mk_query(FilterBuilderArchivedActivityEditionN(), ArchivedActivityEditionNRelationBuilder, uri != undefined ? uri + 'ArchivedActivityEditionN' : 'http://localhost:5000/odata/ArchivedActivityEditionN', ArchivedActivityEditionNParser, ArchivedActivityEditionNOrderBy(""));
export const ArchivedActivityEditionN_ArchivedActivityEventQuery = (uri)=>mk_query(FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(), ArchivedActivityEditionN_ArchivedActivityEventRelationBuilder, uri != undefined ? uri + 'ArchivedActivityEditionN_ArchivedActivityEvent' : 'http://localhost:5000/odata/ArchivedActivityEditionN_ArchivedActivityEvent', ArchivedActivityEditionN_ArchivedActivityEventParser, ArchivedActivityEditionN_ArchivedActivityEventOrderBy(""));
export const ArchivedActivityEditionN_BookQuery = (uri)=>mk_query(FilterBuilderArchivedActivityEditionN_Book(), ArchivedActivityEditionN_BookRelationBuilder, uri != undefined ? uri + 'ArchivedActivityEditionN_Book' : 'http://localhost:5000/odata/ArchivedActivityEditionN_Book', ArchivedActivityEditionN_BookParser, ArchivedActivityEditionN_BookOrderBy(""));
export const ArchivedActivityEventQuery = (uri)=>mk_query(FilterBuilderArchivedActivityEvent(), ArchivedActivityEventRelationBuilder, uri != undefined ? uri + 'ArchivedActivityEvent' : 'http://localhost:5000/odata/ArchivedActivityEvent', ArchivedActivityEventParser, ArchivedActivityEventOrderBy(""));
export const BookQuery = (uri)=>mk_query(FilterBuilderBook(), BookRelationBuilder, uri != undefined ? uri + 'Book' : 'http://localhost:5000/odata/Book', BookParser, BookOrderBy(""));
export const Book_ImageDataQuery = (uri)=>mk_query(FilterBuilderBook_ImageData(), Book_ImageDataRelationBuilder, uri != undefined ? uri + 'Book_ImageData' : 'http://localhost:5000/odata/Book_ImageDatum', Book_ImageDataParser, Book_ImageDataOrderBy(""));
export const ControlPanelQuery = (uri)=>mk_query(FilterBuilderControlPanel(), ControlPanelRelationBuilder, uri != undefined ? uri + 'ControlPanel' : 'http://localhost:5000/odata/ControlPanel', ControlPanelParser, ControlPanelOrderBy(""));
export const HomePageQuery = (uri)=>mk_query(FilterBuilderHomePage(), HomePageRelationBuilder, uri != undefined ? uri + 'HomePage' : 'http://localhost:5000/odata/HomePage', HomePageParser, HomePageOrderBy(""));
export const LocationQuery = (uri)=>mk_query(FilterBuilderLocation(), LocationRelationBuilder, uri != undefined ? uri + 'Location' : 'http://localhost:5000/odata/Location', LocationParser, LocationOrderBy(""));
export const Location_ActivityEditionScheduleQuery = (uri)=>mk_query(FilterBuilderLocation_ActivityEditionSchedule(), Location_ActivityEditionScheduleRelationBuilder, uri != undefined ? uri + 'Location_ActivityEditionSchedule' : 'http://localhost:5000/odata/Location_ActivityEditionSchedule', Location_ActivityEditionScheduleParser, Location_ActivityEditionScheduleOrderBy(""));
export const Location_ActivityEventQuery = (uri)=>mk_query(FilterBuilderLocation_ActivityEvent(), Location_ActivityEventRelationBuilder, uri != undefined ? uri + 'Location_ActivityEvent' : 'http://localhost:5000/odata/Location_ActivityEvent', Location_ActivityEventParser, Location_ActivityEventOrderBy(""));
export const Location_ArchivedActivityEventQuery = (uri)=>mk_query(FilterBuilderLocation_ArchivedActivityEvent(), Location_ArchivedActivityEventRelationBuilder, uri != undefined ? uri + 'Location_ArchivedActivityEvent' : 'http://localhost:5000/odata/Location_ArchivedActivityEvent', Location_ArchivedActivityEventParser, Location_ArchivedActivityEventOrderBy(""));
export const LoginAttemptQuery = (uri)=>mk_query(FilterBuilderLoginAttempt(), LoginAttemptRelationBuilder, uri != undefined ? uri + 'LoginAttempt' : 'http://localhost:5000/odata/LoginAttempt', LoginAttemptParser, LoginAttemptOrderBy(""));
export const PermanentRedirectQuery = (uri)=>mk_query(FilterBuilderPermanentRedirect(), PermanentRedirectRelationBuilder, uri != undefined ? uri + 'PermanentRedirect' : 'http://localhost:5000/odata/PermanentRedirect', PermanentRedirectParser, PermanentRedirectOrderBy(""));
export const RegionQuery = (uri)=>mk_query(FilterBuilderRegion(), RegionRelationBuilder, uri != undefined ? uri + 'Region' : 'http://localhost:5000/odata/Region', RegionParser, RegionOrderBy(""));
export const Region_LocationQuery = (uri)=>mk_query(FilterBuilderRegion_Location(), Region_LocationRelationBuilder, uri != undefined ? uri + 'Region_Location' : 'http://localhost:5000/odata/Region_Location', Region_LocationParser, Region_LocationOrderBy(""));
export const SessionQuery = (uri)=>mk_query(FilterBuilderSession(), SessionRelationBuilder, uri != undefined ? uri + 'Session' : 'http://localhost:5000/odata/Session', SessionParser, SessionOrderBy(""));
function FilterBuilderActivity(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Title: new FilterBuilderString(mk_prefix('Title', prefix)),
        Sticky: new FilterBuilderBoolean(mk_prefix('Sticky', prefix)),
        StickyTip: new FilterBuilderBoolean(mk_prefix('StickyTip', prefix)),
        HideInOverview: new FilterBuilderBoolean(mk_prefix('HideInOverview', prefix)),
        Activity_ActivityEditionN: new FilterBuilderCollection(mk_prefix('Activity_ActivityEditionN', prefix), (s)=>FilterBuilderActivity_ActivityEditionN(s)),
        Activity_ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('Activity_ActivityEditionSchedule', prefix), (s)=>FilterBuilderActivity_ActivityEditionSchedule(s)),
        Activity_ArchivedActivityEditionN: new FilterBuilderCollection(mk_prefix('Activity_ArchivedActivityEditionN', prefix), (s)=>FilterBuilderActivity_ArchivedActivityEditionN(s)),
        ActivityCluster_Activity: new FilterBuilderCollection(mk_prefix('ActivityCluster_Activity', prefix), (s)=>FilterBuilderActivityCluster_Activity(s))
    };
}
const ActivityRelationBuilder = {
    Activity_ActivityEditionN: ()=>mk_rel_query('Activity_ActivityEditionN', FilterBuilderActivity_ActivityEditionN(), Activity_ActivityEditionNRelationBuilder, Activity_ActivityEditionNParser),
    Activity_ActivityEditionSchedule: ()=>mk_rel_query('Activity_ActivityEditionSchedule', FilterBuilderActivity_ActivityEditionSchedule(), Activity_ActivityEditionScheduleRelationBuilder, Activity_ActivityEditionScheduleParser),
    Activity_ArchivedActivityEditionN: ()=>mk_rel_query('Activity_ArchivedActivityEditionN', FilterBuilderActivity_ArchivedActivityEditionN(), Activity_ArchivedActivityEditionNRelationBuilder, Activity_ArchivedActivityEditionNParser),
    ActivityCluster_Activity: ()=>mk_rel_query('ActivityCluster_Activity', FilterBuilderActivityCluster_Activity(), ActivityCluster_ActivityRelationBuilder, ActivityCluster_ActivityParser)
};
const ActivityParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Title: parseNullString,
    Sticky: parseBoolean,
    StickyTip: parseBoolean,
    HideInOverview: parseBoolean,
    Activity_ActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Activity_ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Activity_ArchivedActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ActivityCluster_Activity: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Title: new OrderByProp(p ? p + "/Title" : "Title"),
        Sticky: new OrderByProp(p ? p + "/Sticky" : "Sticky"),
        StickyTip: new OrderByProp(p ? p + "/StickyTip" : "StickyTip"),
        HideInOverview: new OrderByProp(p ? p + "/HideInOverview" : "HideInOverview"),
        Activity_ActivityEditionN: (p)=>Activity_ActivityEditionNOrderBy(p ? p + "/Activity_ActivityEditionN" : "Activity_ActivityEditionN"),
        Activity_ActivityEditionSchedule: (p)=>Activity_ActivityEditionScheduleOrderBy(p ? p + "/Activity_ActivityEditionSchedule" : "Activity_ActivityEditionSchedule"),
        Activity_ArchivedActivityEditionN: (p)=>Activity_ArchivedActivityEditionNOrderBy(p ? p + "/Activity_ArchivedActivityEditionN" : "Activity_ArchivedActivityEditionN"),
        ActivityCluster_Activity: (p)=>ActivityCluster_ActivityOrderBy(p ? p + "/ActivityCluster_Activity" : "ActivityCluster_Activity")
    });
function FilterBuilderActivity_ActivityEditionN(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ActivityId: new FilterBuilderNumber(mk_prefix('ActivityId', prefix)),
        ActivityEditionNId: new FilterBuilderNumber(mk_prefix('ActivityEditionNId', prefix)),
        ActivityEditionN: new FilterBuilderCollection(mk_prefix('ActivityEditionN', prefix), (s)=>FilterBuilderActivityEditionN(s)),
        Activity: new FilterBuilderCollection(mk_prefix('Activity', prefix), (s)=>FilterBuilderActivity(s))
    };
}
const Activity_ActivityEditionNRelationBuilder = {
    ActivityEditionN: ()=>mk_rel_query('ActivityEditionN', FilterBuilderActivityEditionN(), ActivityEditionNRelationBuilder, ActivityEditionNParser),
    Activity: ()=>mk_rel_query('Activity', FilterBuilderActivity(), ActivityRelationBuilder, ActivityParser)
};
const Activity_ActivityEditionNParser = {
    Id: parseNumber,
    ActivityId: parseNumber,
    ActivityEditionNId: parseNumber,
    ActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Activity: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const Activity_ActivityEditionNOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ActivityId: new OrderByProp(p ? p + "/ActivityId" : "ActivityId"),
        ActivityEditionNId: new OrderByProp(p ? p + "/ActivityEditionNId" : "ActivityEditionNId"),
        ActivityEditionN: (p)=>ActivityEditionNOrderBy(p ? p + "/ActivityEditionN" : "ActivityEditionN"),
        Activity: (p)=>ActivityOrderBy(p ? p + "/Activity" : "Activity")
    });
function FilterBuilderActivity_ActivityEditionSchedule(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ActivityId: new FilterBuilderNumber(mk_prefix('ActivityId', prefix)),
        ActivityEditionScheduleId: new FilterBuilderNumber(mk_prefix('ActivityEditionScheduleId', prefix)),
        ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('ActivityEditionSchedule', prefix), (s)=>FilterBuilderActivityEditionSchedule(s)),
        Activity: new FilterBuilderCollection(mk_prefix('Activity', prefix), (s)=>FilterBuilderActivity(s))
    };
}
const Activity_ActivityEditionScheduleRelationBuilder = {
    ActivityEditionSchedule: ()=>mk_rel_query('ActivityEditionSchedule', FilterBuilderActivityEditionSchedule(), ActivityEditionScheduleRelationBuilder, ActivityEditionScheduleParser),
    Activity: ()=>mk_rel_query('Activity', FilterBuilderActivity(), ActivityRelationBuilder, ActivityParser)
};
const Activity_ActivityEditionScheduleParser = {
    Id: parseNumber,
    ActivityId: parseNumber,
    ActivityEditionScheduleId: parseNumber,
    ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Activity: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const Activity_ActivityEditionScheduleOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ActivityId: new OrderByProp(p ? p + "/ActivityId" : "ActivityId"),
        ActivityEditionScheduleId: new OrderByProp(p ? p + "/ActivityEditionScheduleId" : "ActivityEditionScheduleId"),
        ActivityEditionSchedule: (p)=>ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionSchedule" : "ActivityEditionSchedule"),
        Activity: (p)=>ActivityOrderBy(p ? p + "/Activity" : "Activity")
    });
function FilterBuilderActivity_ArchivedActivityEditionN(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ActivityId: new FilterBuilderNumber(mk_prefix('ActivityId', prefix)),
        ArchivedActivityEditionNId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEditionNId', prefix)),
        Activity: new FilterBuilderCollection(mk_prefix('Activity', prefix), (s)=>FilterBuilderActivity(s)),
        ArchivedActivityEditionN: new FilterBuilderCollection(mk_prefix('ArchivedActivityEditionN', prefix), (s)=>FilterBuilderArchivedActivityEditionN(s))
    };
}
const Activity_ArchivedActivityEditionNRelationBuilder = {
    Activity: ()=>mk_rel_query('Activity', FilterBuilderActivity(), ActivityRelationBuilder, ActivityParser),
    ArchivedActivityEditionN: ()=>mk_rel_query('ArchivedActivityEditionN', FilterBuilderArchivedActivityEditionN(), ArchivedActivityEditionNRelationBuilder, ArchivedActivityEditionNParser)
};
const Activity_ArchivedActivityEditionNParser = {
    Id: parseNumber,
    ActivityId: parseNumber,
    ArchivedActivityEditionNId: parseNumber,
    Activity: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ArchivedActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const Activity_ArchivedActivityEditionNOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ActivityId: new OrderByProp(p ? p + "/ActivityId" : "ActivityId"),
        ArchivedActivityEditionNId: new OrderByProp(p ? p + "/ArchivedActivityEditionNId" : "ArchivedActivityEditionNId"),
        Activity: (p)=>ActivityOrderBy(p ? p + "/Activity" : "Activity"),
        ArchivedActivityEditionN: (p)=>ArchivedActivityEditionNOrderBy(p ? p + "/ArchivedActivityEditionN" : "ArchivedActivityEditionN")
    });
function FilterBuilderActivityCluster(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Title: new FilterBuilderString(mk_prefix('Title', prefix)),
        Description: new FilterBuilderString(mk_prefix('Description', prefix)),
        Slug: new FilterBuilderString(mk_prefix('Slug', prefix)),
        ActivityCluster_Activity: new FilterBuilderCollection(mk_prefix('ActivityCluster_Activity', prefix), (s)=>FilterBuilderActivityCluster_Activity(s))
    };
}
const ActivityClusterRelationBuilder = {
    ActivityCluster_Activity: ()=>mk_rel_query('ActivityCluster_Activity', FilterBuilderActivityCluster_Activity(), ActivityCluster_ActivityRelationBuilder, ActivityCluster_ActivityParser)
};
const ActivityClusterParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Title: parseNullString,
    Description: parseNullString,
    Slug: parseNullString,
    ActivityCluster_Activity: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityClusterOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Title: new OrderByProp(p ? p + "/Title" : "Title"),
        Description: new OrderByProp(p ? p + "/Description" : "Description"),
        Slug: new OrderByProp(p ? p + "/Slug" : "Slug"),
        ActivityCluster_Activity: (p)=>ActivityCluster_ActivityOrderBy(p ? p + "/ActivityCluster_Activity" : "ActivityCluster_Activity")
    });
function FilterBuilderActivityCluster_Activity(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ActivityClusterId: new FilterBuilderNumber(mk_prefix('ActivityClusterId', prefix)),
        ActivityId: new FilterBuilderNumber(mk_prefix('ActivityId', prefix)),
        ActivityCluster: new FilterBuilderCollection(mk_prefix('ActivityCluster', prefix), (s)=>FilterBuilderActivityCluster(s)),
        Activity: new FilterBuilderCollection(mk_prefix('Activity', prefix), (s)=>FilterBuilderActivity(s))
    };
}
const ActivityCluster_ActivityRelationBuilder = {
    ActivityCluster: ()=>mk_rel_query('ActivityCluster', FilterBuilderActivityCluster(), ActivityClusterRelationBuilder, ActivityClusterParser),
    Activity: ()=>mk_rel_query('Activity', FilterBuilderActivity(), ActivityRelationBuilder, ActivityParser)
};
const ActivityCluster_ActivityParser = {
    Id: parseNumber,
    ActivityClusterId: parseNumber,
    ActivityId: parseNumber,
    ActivityCluster: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Activity: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityCluster_ActivityOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ActivityClusterId: new OrderByProp(p ? p + "/ActivityClusterId" : "ActivityClusterId"),
        ActivityId: new OrderByProp(p ? p + "/ActivityId" : "ActivityId"),
        ActivityCluster: (p)=>ActivityClusterOrderBy(p ? p + "/ActivityCluster" : "ActivityCluster"),
        Activity: (p)=>ActivityOrderBy(p ? p + "/Activity" : "Activity")
    });
function FilterBuilderActivityEditionN(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        SignupText: new FilterBuilderString(mk_prefix('SignupText', prefix)),
        SignupURL: new FilterBuilderString(mk_prefix('SignupURL', prefix)),
        Cost: new FilterBuilderString(mk_prefix('Cost', prefix)),
        Activity_ActivityEditionN: new FilterBuilderCollection(mk_prefix('Activity_ActivityEditionN', prefix), (s)=>FilterBuilderActivity_ActivityEditionN(s)),
        ActivityEditionN_ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('ActivityEditionN_ActivityEditionSchedule', prefix), (s)=>FilterBuilderActivityEditionN_ActivityEditionSchedule(s)),
        ActivityEditionN_ActivityEvent: new FilterBuilderCollection(mk_prefix('ActivityEditionN_ActivityEvent', prefix), (s)=>FilterBuilderActivityEditionN_ActivityEvent(s)),
        ActivityEditionN_Book: new FilterBuilderCollection(mk_prefix('ActivityEditionN_Book', prefix), (s)=>FilterBuilderActivityEditionN_Book(s))
    };
}
const ActivityEditionNRelationBuilder = {
    Activity_ActivityEditionN: ()=>mk_rel_query('Activity_ActivityEditionN', FilterBuilderActivity_ActivityEditionN(), Activity_ActivityEditionNRelationBuilder, Activity_ActivityEditionNParser),
    ActivityEditionN_ActivityEditionSchedule: ()=>mk_rel_query('ActivityEditionN_ActivityEditionSchedule', FilterBuilderActivityEditionN_ActivityEditionSchedule(), ActivityEditionN_ActivityEditionScheduleRelationBuilder, ActivityEditionN_ActivityEditionScheduleParser),
    ActivityEditionN_ActivityEvent: ()=>mk_rel_query('ActivityEditionN_ActivityEvent', FilterBuilderActivityEditionN_ActivityEvent(), ActivityEditionN_ActivityEventRelationBuilder, ActivityEditionN_ActivityEventParser),
    ActivityEditionN_Book: ()=>mk_rel_query('ActivityEditionN_Book', FilterBuilderActivityEditionN_Book(), ActivityEditionN_BookRelationBuilder, ActivityEditionN_BookParser)
};
const ActivityEditionNParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    SignupText: parseNullString,
    SignupURL: parseNullString,
    Cost: parseNullString,
    Activity_ActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ActivityEditionN_ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ActivityEditionN_ActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ActivityEditionN_Book: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityEditionNOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        SignupText: new OrderByProp(p ? p + "/SignupText" : "SignupText"),
        SignupURL: new OrderByProp(p ? p + "/SignupURL" : "SignupURL"),
        Cost: new OrderByProp(p ? p + "/Cost" : "Cost"),
        Activity_ActivityEditionN: (p)=>Activity_ActivityEditionNOrderBy(p ? p + "/Activity_ActivityEditionN" : "Activity_ActivityEditionN"),
        ActivityEditionN_ActivityEditionSchedule: (p)=>ActivityEditionN_ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionN_ActivityEditionSchedule" : "ActivityEditionN_ActivityEditionSchedule"),
        ActivityEditionN_ActivityEvent: (p)=>ActivityEditionN_ActivityEventOrderBy(p ? p + "/ActivityEditionN_ActivityEvent" : "ActivityEditionN_ActivityEvent"),
        ActivityEditionN_Book: (p)=>ActivityEditionN_BookOrderBy(p ? p + "/ActivityEditionN_Book" : "ActivityEditionN_Book")
    });
function FilterBuilderActivityEditionN_ActivityEditionSchedule(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ActivityEditionNId: new FilterBuilderNumber(mk_prefix('ActivityEditionNId', prefix)),
        ActivityEditionScheduleId: new FilterBuilderNumber(mk_prefix('ActivityEditionScheduleId', prefix)),
        ActivityEditionN: new FilterBuilderCollection(mk_prefix('ActivityEditionN', prefix), (s)=>FilterBuilderActivityEditionN(s)),
        ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('ActivityEditionSchedule', prefix), (s)=>FilterBuilderActivityEditionSchedule(s))
    };
}
const ActivityEditionN_ActivityEditionScheduleRelationBuilder = {
    ActivityEditionN: ()=>mk_rel_query('ActivityEditionN', FilterBuilderActivityEditionN(), ActivityEditionNRelationBuilder, ActivityEditionNParser),
    ActivityEditionSchedule: ()=>mk_rel_query('ActivityEditionSchedule', FilterBuilderActivityEditionSchedule(), ActivityEditionScheduleRelationBuilder, ActivityEditionScheduleParser)
};
const ActivityEditionN_ActivityEditionScheduleParser = {
    Id: parseNumber,
    ActivityEditionNId: parseNumber,
    ActivityEditionScheduleId: parseNumber,
    ActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityEditionN_ActivityEditionScheduleOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ActivityEditionNId: new OrderByProp(p ? p + "/ActivityEditionNId" : "ActivityEditionNId"),
        ActivityEditionScheduleId: new OrderByProp(p ? p + "/ActivityEditionScheduleId" : "ActivityEditionScheduleId"),
        ActivityEditionN: (p)=>ActivityEditionNOrderBy(p ? p + "/ActivityEditionN" : "ActivityEditionN"),
        ActivityEditionSchedule: (p)=>ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionSchedule" : "ActivityEditionSchedule")
    });
function FilterBuilderActivityEditionN_ActivityEvent(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ActivityEditionNId: new FilterBuilderNumber(mk_prefix('ActivityEditionNId', prefix)),
        ActivityEventId: new FilterBuilderNumber(mk_prefix('ActivityEventId', prefix)),
        ActivityEditionN: new FilterBuilderCollection(mk_prefix('ActivityEditionN', prefix), (s)=>FilterBuilderActivityEditionN(s)),
        ActivityEvent: new FilterBuilderCollection(mk_prefix('ActivityEvent', prefix), (s)=>FilterBuilderActivityEvent(s))
    };
}
const ActivityEditionN_ActivityEventRelationBuilder = {
    ActivityEditionN: ()=>mk_rel_query('ActivityEditionN', FilterBuilderActivityEditionN(), ActivityEditionNRelationBuilder, ActivityEditionNParser),
    ActivityEvent: ()=>mk_rel_query('ActivityEvent', FilterBuilderActivityEvent(), ActivityEventRelationBuilder, ActivityEventParser)
};
const ActivityEditionN_ActivityEventParser = {
    Id: parseNumber,
    ActivityEditionNId: parseNumber,
    ActivityEventId: parseNumber,
    ActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityEditionN_ActivityEventOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ActivityEditionNId: new OrderByProp(p ? p + "/ActivityEditionNId" : "ActivityEditionNId"),
        ActivityEventId: new OrderByProp(p ? p + "/ActivityEventId" : "ActivityEventId"),
        ActivityEditionN: (p)=>ActivityEditionNOrderBy(p ? p + "/ActivityEditionN" : "ActivityEditionN"),
        ActivityEvent: (p)=>ActivityEventOrderBy(p ? p + "/ActivityEvent" : "ActivityEvent")
    });
function FilterBuilderActivityEditionN_Book(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ActivityEditionNId: new FilterBuilderNumber(mk_prefix('ActivityEditionNId', prefix)),
        BookId: new FilterBuilderNumber(mk_prefix('BookId', prefix)),
        ActivityEditionN: new FilterBuilderCollection(mk_prefix('ActivityEditionN', prefix), (s)=>FilterBuilderActivityEditionN(s)),
        Book: new FilterBuilderCollection(mk_prefix('Book', prefix), (s)=>FilterBuilderBook(s))
    };
}
const ActivityEditionN_BookRelationBuilder = {
    ActivityEditionN: ()=>mk_rel_query('ActivityEditionN', FilterBuilderActivityEditionN(), ActivityEditionNRelationBuilder, ActivityEditionNParser),
    Book: ()=>mk_rel_query('Book', FilterBuilderBook(), BookRelationBuilder, BookParser)
};
const ActivityEditionN_BookParser = {
    Id: parseNumber,
    ActivityEditionNId: parseNumber,
    BookId: parseNumber,
    ActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Book: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityEditionN_BookOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ActivityEditionNId: new OrderByProp(p ? p + "/ActivityEditionNId" : "ActivityEditionNId"),
        BookId: new OrderByProp(p ? p + "/BookId" : "BookId"),
        ActivityEditionN: (p)=>ActivityEditionNOrderBy(p ? p + "/ActivityEditionN" : "ActivityEditionN"),
        Book: (p)=>BookOrderBy(p ? p + "/Book" : "Book")
    });
function FilterBuilderActivityEditionSchedule(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Plan: new FilterBuilderString(mk_prefix('Plan', prefix)),
        Activity_ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('Activity_ActivityEditionSchedule', prefix), (s)=>FilterBuilderActivity_ActivityEditionSchedule(s)),
        ActivityEditionN_ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('ActivityEditionN_ActivityEditionSchedule', prefix), (s)=>FilterBuilderActivityEditionN_ActivityEditionSchedule(s)),
        Location_ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('Location_ActivityEditionSchedule', prefix), (s)=>FilterBuilderLocation_ActivityEditionSchedule(s))
    };
}
const ActivityEditionScheduleRelationBuilder = {
    Activity_ActivityEditionSchedule: ()=>mk_rel_query('Activity_ActivityEditionSchedule', FilterBuilderActivity_ActivityEditionSchedule(), Activity_ActivityEditionScheduleRelationBuilder, Activity_ActivityEditionScheduleParser),
    ActivityEditionN_ActivityEditionSchedule: ()=>mk_rel_query('ActivityEditionN_ActivityEditionSchedule', FilterBuilderActivityEditionN_ActivityEditionSchedule(), ActivityEditionN_ActivityEditionScheduleRelationBuilder, ActivityEditionN_ActivityEditionScheduleParser),
    Location_ActivityEditionSchedule: ()=>mk_rel_query('Location_ActivityEditionSchedule', FilterBuilderLocation_ActivityEditionSchedule(), Location_ActivityEditionScheduleRelationBuilder, Location_ActivityEditionScheduleParser)
};
const ActivityEditionScheduleParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Plan: parseNullString,
    Activity_ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ActivityEditionN_ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Location_ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityEditionScheduleOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Plan: new OrderByProp(p ? p + "/Plan" : "Plan"),
        Activity_ActivityEditionSchedule: (p)=>Activity_ActivityEditionScheduleOrderBy(p ? p + "/Activity_ActivityEditionSchedule" : "Activity_ActivityEditionSchedule"),
        ActivityEditionN_ActivityEditionSchedule: (p)=>ActivityEditionN_ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionN_ActivityEditionSchedule" : "ActivityEditionN_ActivityEditionSchedule"),
        Location_ActivityEditionSchedule: (p)=>Location_ActivityEditionScheduleOrderBy(p ? p + "/Location_ActivityEditionSchedule" : "Location_ActivityEditionSchedule")
    });
function FilterBuilderActivityEvent(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Date: new FilterBuilderDate(mk_prefix('Date', prefix)),
        Start: new FilterBuilderString(mk_prefix('Start', prefix)),
        End: new FilterBuilderString(mk_prefix('End', prefix)),
        ActivityEditionN_ActivityEvent: new FilterBuilderCollection(mk_prefix('ActivityEditionN_ActivityEvent', prefix), (s)=>FilterBuilderActivityEditionN_ActivityEvent(s)),
        Location_ActivityEvent: new FilterBuilderCollection(mk_prefix('Location_ActivityEvent', prefix), (s)=>FilterBuilderLocation_ActivityEvent(s))
    };
}
const ActivityEventRelationBuilder = {
    ActivityEditionN_ActivityEvent: ()=>mk_rel_query('ActivityEditionN_ActivityEvent', FilterBuilderActivityEditionN_ActivityEvent(), ActivityEditionN_ActivityEventRelationBuilder, ActivityEditionN_ActivityEventParser),
    Location_ActivityEvent: ()=>mk_rel_query('Location_ActivityEvent', FilterBuilderLocation_ActivityEvent(), Location_ActivityEventRelationBuilder, Location_ActivityEventParser)
};
const ActivityEventParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Date: parseDate,
    Start: parseNullString,
    End: parseNullString,
    ActivityEditionN_ActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Location_ActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ActivityEventOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Date: new OrderByProp(p ? p + "/Date" : "Date"),
        Start: new OrderByProp(p ? p + "/Start" : "Start"),
        End: new OrderByProp(p ? p + "/End" : "End"),
        ActivityEditionN_ActivityEvent: (p)=>ActivityEditionN_ActivityEventOrderBy(p ? p + "/ActivityEditionN_ActivityEvent" : "ActivityEditionN_ActivityEvent"),
        Location_ActivityEvent: (p)=>Location_ActivityEventOrderBy(p ? p + "/Location_ActivityEvent" : "Location_ActivityEvent")
    });
function FilterBuilderAdmin(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Username: new FilterBuilderString(mk_prefix('Username', prefix)),
        Language: new FilterBuilderString(mk_prefix('Language', prefix)),
        Email: new FilterBuilderString(mk_prefix('Email', prefix)),
        PasswordHash: new FilterBuilderString(mk_prefix('PasswordHash', prefix)),
        PasswordSalt: new FilterBuilderString(mk_prefix('PasswordSalt', prefix)),
        LastLoginAttempt: new FilterBuilderDate(mk_prefix('LastLoginAttempt', prefix)),
        SecurityStamp: new FilterBuilderString(mk_prefix('SecurityStamp', prefix)),
        EmailConfirmed: new FilterBuilderBoolean(mk_prefix('EmailConfirmed', prefix))
    };
}
const AdminRelationBuilder = {};
const AdminParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Username: parseNullString,
    Language: parseNullString,
    Email: parseNullString,
    PasswordHash: parseNullString,
    PasswordSalt: parseNullString,
    LastLoginAttempt: parseDate,
    SecurityStamp: parseNullString,
    EmailConfirmed: parseBoolean
};
const AdminOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Username: new OrderByProp(p ? p + "/Username" : "Username"),
        Language: new OrderByProp(p ? p + "/Language" : "Language"),
        Email: new OrderByProp(p ? p + "/Email" : "Email"),
        PasswordHash: new OrderByProp(p ? p + "/PasswordHash" : "PasswordHash"),
        PasswordSalt: new OrderByProp(p ? p + "/PasswordSalt" : "PasswordSalt"),
        LastLoginAttempt: new OrderByProp(p ? p + "/LastLoginAttempt" : "LastLoginAttempt"),
        SecurityStamp: new OrderByProp(p ? p + "/SecurityStamp" : "SecurityStamp"),
        EmailConfirmed: new OrderByProp(p ? p + "/EmailConfirmed" : "EmailConfirmed")
    });
function FilterBuilderArchivedActivityEditionN(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        SignupText: new FilterBuilderString(mk_prefix('SignupText', prefix)),
        SignupURL: new FilterBuilderString(mk_prefix('SignupURL', prefix)),
        Cost: new FilterBuilderString(mk_prefix('Cost', prefix)),
        Activity_ArchivedActivityEditionN: new FilterBuilderCollection(mk_prefix('Activity_ArchivedActivityEditionN', prefix), (s)=>FilterBuilderActivity_ArchivedActivityEditionN(s)),
        ArchivedActivityEditionN_ArchivedActivityEvent: new FilterBuilderCollection(mk_prefix('ArchivedActivityEditionN_ArchivedActivityEvent', prefix), (s)=>FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(s)),
        ArchivedActivityEditionN_Book: new FilterBuilderCollection(mk_prefix('ArchivedActivityEditionN_Book', prefix), (s)=>FilterBuilderArchivedActivityEditionN_Book(s))
    };
}
const ArchivedActivityEditionNRelationBuilder = {
    Activity_ArchivedActivityEditionN: ()=>mk_rel_query('Activity_ArchivedActivityEditionN', FilterBuilderActivity_ArchivedActivityEditionN(), Activity_ArchivedActivityEditionNRelationBuilder, Activity_ArchivedActivityEditionNParser),
    ArchivedActivityEditionN_ArchivedActivityEvent: ()=>mk_rel_query('ArchivedActivityEditionN_ArchivedActivityEvent', FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(), ArchivedActivityEditionN_ArchivedActivityEventRelationBuilder, ArchivedActivityEditionN_ArchivedActivityEventParser),
    ArchivedActivityEditionN_Book: ()=>mk_rel_query('ArchivedActivityEditionN_Book', FilterBuilderArchivedActivityEditionN_Book(), ArchivedActivityEditionN_BookRelationBuilder, ArchivedActivityEditionN_BookParser)
};
const ArchivedActivityEditionNParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    SignupText: parseNullString,
    SignupURL: parseNullString,
    Cost: parseNullString,
    Activity_ArchivedActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ArchivedActivityEditionN_ArchivedActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ArchivedActivityEditionN_Book: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ArchivedActivityEditionNOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        SignupText: new OrderByProp(p ? p + "/SignupText" : "SignupText"),
        SignupURL: new OrderByProp(p ? p + "/SignupURL" : "SignupURL"),
        Cost: new OrderByProp(p ? p + "/Cost" : "Cost"),
        Activity_ArchivedActivityEditionN: (p)=>Activity_ArchivedActivityEditionNOrderBy(p ? p + "/Activity_ArchivedActivityEditionN" : "Activity_ArchivedActivityEditionN"),
        ArchivedActivityEditionN_ArchivedActivityEvent: (p)=>ArchivedActivityEditionN_ArchivedActivityEventOrderBy(p ? p + "/ArchivedActivityEditionN_ArchivedActivityEvent" : "ArchivedActivityEditionN_ArchivedActivityEvent"),
        ArchivedActivityEditionN_Book: (p)=>ArchivedActivityEditionN_BookOrderBy(p ? p + "/ArchivedActivityEditionN_Book" : "ArchivedActivityEditionN_Book")
    });
function FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ArchivedActivityEditionNId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEditionNId', prefix)),
        ArchivedActivityEventId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEventId', prefix)),
        ArchivedActivityEditionN: new FilterBuilderCollection(mk_prefix('ArchivedActivityEditionN', prefix), (s)=>FilterBuilderArchivedActivityEditionN(s)),
        ArchivedActivityEvent: new FilterBuilderCollection(mk_prefix('ArchivedActivityEvent', prefix), (s)=>FilterBuilderArchivedActivityEvent(s))
    };
}
const ArchivedActivityEditionN_ArchivedActivityEventRelationBuilder = {
    ArchivedActivityEditionN: ()=>mk_rel_query('ArchivedActivityEditionN', FilterBuilderArchivedActivityEditionN(), ArchivedActivityEditionNRelationBuilder, ArchivedActivityEditionNParser),
    ArchivedActivityEvent: ()=>mk_rel_query('ArchivedActivityEvent', FilterBuilderArchivedActivityEvent(), ArchivedActivityEventRelationBuilder, ArchivedActivityEventParser)
};
const ArchivedActivityEditionN_ArchivedActivityEventParser = {
    Id: parseNumber,
    ArchivedActivityEditionNId: parseNumber,
    ArchivedActivityEventId: parseNumber,
    ArchivedActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ArchivedActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ArchivedActivityEditionN_ArchivedActivityEventOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ArchivedActivityEditionNId: new OrderByProp(p ? p + "/ArchivedActivityEditionNId" : "ArchivedActivityEditionNId"),
        ArchivedActivityEventId: new OrderByProp(p ? p + "/ArchivedActivityEventId" : "ArchivedActivityEventId"),
        ArchivedActivityEditionN: (p)=>ArchivedActivityEditionNOrderBy(p ? p + "/ArchivedActivityEditionN" : "ArchivedActivityEditionN"),
        ArchivedActivityEvent: (p)=>ArchivedActivityEventOrderBy(p ? p + "/ArchivedActivityEvent" : "ArchivedActivityEvent")
    });
function FilterBuilderArchivedActivityEditionN_Book(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        ArchivedActivityEditionNId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEditionNId', prefix)),
        BookId: new FilterBuilderNumber(mk_prefix('BookId', prefix)),
        ArchivedActivityEditionN: new FilterBuilderCollection(mk_prefix('ArchivedActivityEditionN', prefix), (s)=>FilterBuilderArchivedActivityEditionN(s)),
        Book: new FilterBuilderCollection(mk_prefix('Book', prefix), (s)=>FilterBuilderBook(s))
    };
}
const ArchivedActivityEditionN_BookRelationBuilder = {
    ArchivedActivityEditionN: ()=>mk_rel_query('ArchivedActivityEditionN', FilterBuilderArchivedActivityEditionN(), ArchivedActivityEditionNRelationBuilder, ArchivedActivityEditionNParser),
    Book: ()=>mk_rel_query('Book', FilterBuilderBook(), BookRelationBuilder, BookParser)
};
const ArchivedActivityEditionN_BookParser = {
    Id: parseNumber,
    ArchivedActivityEditionNId: parseNumber,
    BookId: parseNumber,
    ArchivedActivityEditionN: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Book: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ArchivedActivityEditionN_BookOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        ArchivedActivityEditionNId: new OrderByProp(p ? p + "/ArchivedActivityEditionNId" : "ArchivedActivityEditionNId"),
        BookId: new OrderByProp(p ? p + "/BookId" : "BookId"),
        ArchivedActivityEditionN: (p)=>ArchivedActivityEditionNOrderBy(p ? p + "/ArchivedActivityEditionN" : "ArchivedActivityEditionN"),
        Book: (p)=>BookOrderBy(p ? p + "/Book" : "Book")
    });
function FilterBuilderArchivedActivityEvent(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Date: new FilterBuilderDate(mk_prefix('Date', prefix)),
        Start: new FilterBuilderString(mk_prefix('Start', prefix)),
        End: new FilterBuilderString(mk_prefix('End', prefix)),
        ArchivedActivityEditionN_ArchivedActivityEvent: new FilterBuilderCollection(mk_prefix('ArchivedActivityEditionN_ArchivedActivityEvent', prefix), (s)=>FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(s)),
        Location_ArchivedActivityEvent: new FilterBuilderCollection(mk_prefix('Location_ArchivedActivityEvent', prefix), (s)=>FilterBuilderLocation_ArchivedActivityEvent(s))
    };
}
const ArchivedActivityEventRelationBuilder = {
    ArchivedActivityEditionN_ArchivedActivityEvent: ()=>mk_rel_query('ArchivedActivityEditionN_ArchivedActivityEvent', FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(), ArchivedActivityEditionN_ArchivedActivityEventRelationBuilder, ArchivedActivityEditionN_ArchivedActivityEventParser),
    Location_ArchivedActivityEvent: ()=>mk_rel_query('Location_ArchivedActivityEvent', FilterBuilderLocation_ArchivedActivityEvent(), Location_ArchivedActivityEventRelationBuilder, Location_ArchivedActivityEventParser)
};
const ArchivedActivityEventParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Date: parseDate,
    Start: parseNullString,
    End: parseNullString,
    ArchivedActivityEditionN_ArchivedActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Location_ArchivedActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const ArchivedActivityEventOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Date: new OrderByProp(p ? p + "/Date" : "Date"),
        Start: new OrderByProp(p ? p + "/Start" : "Start"),
        End: new OrderByProp(p ? p + "/End" : "End"),
        ArchivedActivityEditionN_ArchivedActivityEvent: (p)=>ArchivedActivityEditionN_ArchivedActivityEventOrderBy(p ? p + "/ArchivedActivityEditionN_ArchivedActivityEvent" : "ArchivedActivityEditionN_ArchivedActivityEvent"),
        Location_ArchivedActivityEvent: (p)=>Location_ArchivedActivityEventOrderBy(p ? p + "/Location_ArchivedActivityEvent" : "Location_ArchivedActivityEvent")
    });
function FilterBuilderBook(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Name: new FilterBuilderString(mk_prefix('Name', prefix)),
        Author: new FilterBuilderString(mk_prefix('Author', prefix)),
        Image: new FilterBuilderString(mk_prefix('Image', prefix)),
        URL: new FilterBuilderString(mk_prefix('URL', prefix)),
        ActivityEditionN_Book: new FilterBuilderCollection(mk_prefix('ActivityEditionN_Book', prefix), (s)=>FilterBuilderActivityEditionN_Book(s)),
        ArchivedActivityEditionN_Book: new FilterBuilderCollection(mk_prefix('ArchivedActivityEditionN_Book', prefix), (s)=>FilterBuilderArchivedActivityEditionN_Book(s)),
        Book_ImageData: new FilterBuilderCollection(mk_prefix('Book_ImageData', prefix), (s)=>FilterBuilderBook_ImageData(s))
    };
}
const BookRelationBuilder = {
    ActivityEditionN_Book: ()=>mk_rel_query('ActivityEditionN_Book', FilterBuilderActivityEditionN_Book(), ActivityEditionN_BookRelationBuilder, ActivityEditionN_BookParser),
    ArchivedActivityEditionN_Book: ()=>mk_rel_query('ArchivedActivityEditionN_Book', FilterBuilderArchivedActivityEditionN_Book(), ArchivedActivityEditionN_BookRelationBuilder, ArchivedActivityEditionN_BookParser),
    Book_ImageData: ()=>mk_rel_query('Book_ImageData', FilterBuilderBook_ImageData(), Book_ImageDataRelationBuilder, Book_ImageDataParser)
};
const BookParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Name: parseNullString,
    Author: parseNullString,
    Image: parseNullString,
    URL: parseNullString,
    ActivityEditionN_Book: (p)=>parseCollection((x)=>parseEntity(x, p)),
    ArchivedActivityEditionN_Book: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Book_ImageData: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const BookOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Name: new OrderByProp(p ? p + "/Name" : "Name"),
        Author: new OrderByProp(p ? p + "/Author" : "Author"),
        Image: new OrderByProp(p ? p + "/Image" : "Image"),
        URL: new OrderByProp(p ? p + "/URL" : "URL"),
        ActivityEditionN_Book: (p)=>ActivityEditionN_BookOrderBy(p ? p + "/ActivityEditionN_Book" : "ActivityEditionN_Book"),
        ArchivedActivityEditionN_Book: (p)=>ArchivedActivityEditionN_BookOrderBy(p ? p + "/ArchivedActivityEditionN_Book" : "ArchivedActivityEditionN_Book"),
        Book_ImageData: (p)=>Book_ImageDataOrderBy(p ? p + "/Book_ImageData" : "Book_ImageData")
    });
function FilterBuilderBook_ImageData(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        Content: new FilterBuilderString(mk_prefix('Content', prefix)),
        FileName: new FilterBuilderString(mk_prefix('FileName', prefix)),
        ContentType: new FilterBuilderString(mk_prefix('ContentType', prefix)),
        BookId: new FilterBuilderNumber(mk_prefix('BookId', prefix)),
        Book: new FilterBuilderCollection(mk_prefix('Book', prefix), (s)=>FilterBuilderBook(s))
    };
}
const Book_ImageDataRelationBuilder = {
    Book: ()=>mk_rel_query('Book', FilterBuilderBook(), BookRelationBuilder, BookParser)
};
const Book_ImageDataParser = {
    Id: parseNumber,
    Content: parseNullString,
    FileName: parseNullString,
    ContentType: parseNullString,
    BookId: parseNumber,
    Book: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const Book_ImageDataOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        Content: new OrderByProp(p ? p + "/Content" : "Content"),
        FileName: new OrderByProp(p ? p + "/FileName" : "FileName"),
        ContentType: new OrderByProp(p ? p + "/ContentType" : "ContentType"),
        BookId: new OrderByProp(p ? p + "/BookId" : "BookId"),
        Book: (p)=>BookOrderBy(p ? p + "/Book" : "Book")
    });
function FilterBuilderControlPanel(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix))
    };
}
const ControlPanelRelationBuilder = {};
const ControlPanelParser = {
    Id: parseNumber,
    CreatedDate: parseDate
};
const ControlPanelOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate")
    });
function FilterBuilderHomePage(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix))
    };
}
const HomePageRelationBuilder = {};
const HomePageParser = {
    Id: parseNumber,
    CreatedDate: parseDate
};
const HomePageOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate")
    });
function FilterBuilderLocation(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Title: new FilterBuilderString(mk_prefix('Title', prefix)),
        Location_ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('Location_ActivityEditionSchedule', prefix), (s)=>FilterBuilderLocation_ActivityEditionSchedule(s)),
        Location_ActivityEvent: new FilterBuilderCollection(mk_prefix('Location_ActivityEvent', prefix), (s)=>FilterBuilderLocation_ActivityEvent(s)),
        Location_ArchivedActivityEvent: new FilterBuilderCollection(mk_prefix('Location_ArchivedActivityEvent', prefix), (s)=>FilterBuilderLocation_ArchivedActivityEvent(s)),
        Region_Location: new FilterBuilderCollection(mk_prefix('Region_Location', prefix), (s)=>FilterBuilderRegion_Location(s))
    };
}
const LocationRelationBuilder = {
    Location_ActivityEditionSchedule: ()=>mk_rel_query('Location_ActivityEditionSchedule', FilterBuilderLocation_ActivityEditionSchedule(), Location_ActivityEditionScheduleRelationBuilder, Location_ActivityEditionScheduleParser),
    Location_ActivityEvent: ()=>mk_rel_query('Location_ActivityEvent', FilterBuilderLocation_ActivityEvent(), Location_ActivityEventRelationBuilder, Location_ActivityEventParser),
    Location_ArchivedActivityEvent: ()=>mk_rel_query('Location_ArchivedActivityEvent', FilterBuilderLocation_ArchivedActivityEvent(), Location_ArchivedActivityEventRelationBuilder, Location_ArchivedActivityEventParser),
    Region_Location: ()=>mk_rel_query('Region_Location', FilterBuilderRegion_Location(), Region_LocationRelationBuilder, Region_LocationParser)
};
const LocationParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Title: parseNullString,
    Location_ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Location_ActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Location_ArchivedActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Region_Location: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const LocationOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Title: new OrderByProp(p ? p + "/Title" : "Title"),
        Location_ActivityEditionSchedule: (p)=>Location_ActivityEditionScheduleOrderBy(p ? p + "/Location_ActivityEditionSchedule" : "Location_ActivityEditionSchedule"),
        Location_ActivityEvent: (p)=>Location_ActivityEventOrderBy(p ? p + "/Location_ActivityEvent" : "Location_ActivityEvent"),
        Location_ArchivedActivityEvent: (p)=>Location_ArchivedActivityEventOrderBy(p ? p + "/Location_ArchivedActivityEvent" : "Location_ArchivedActivityEvent"),
        Region_Location: (p)=>Region_LocationOrderBy(p ? p + "/Region_Location" : "Region_Location")
    });
function FilterBuilderLocation_ActivityEditionSchedule(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        LocationId: new FilterBuilderNumber(mk_prefix('LocationId', prefix)),
        ActivityEditionScheduleId: new FilterBuilderNumber(mk_prefix('ActivityEditionScheduleId', prefix)),
        ActivityEditionSchedule: new FilterBuilderCollection(mk_prefix('ActivityEditionSchedule', prefix), (s)=>FilterBuilderActivityEditionSchedule(s)),
        Location: new FilterBuilderCollection(mk_prefix('Location', prefix), (s)=>FilterBuilderLocation(s))
    };
}
const Location_ActivityEditionScheduleRelationBuilder = {
    ActivityEditionSchedule: ()=>mk_rel_query('ActivityEditionSchedule', FilterBuilderActivityEditionSchedule(), ActivityEditionScheduleRelationBuilder, ActivityEditionScheduleParser),
    Location: ()=>mk_rel_query('Location', FilterBuilderLocation(), LocationRelationBuilder, LocationParser)
};
const Location_ActivityEditionScheduleParser = {
    Id: parseNumber,
    LocationId: parseNumber,
    ActivityEditionScheduleId: parseNumber,
    ActivityEditionSchedule: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Location: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const Location_ActivityEditionScheduleOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        LocationId: new OrderByProp(p ? p + "/LocationId" : "LocationId"),
        ActivityEditionScheduleId: new OrderByProp(p ? p + "/ActivityEditionScheduleId" : "ActivityEditionScheduleId"),
        ActivityEditionSchedule: (p)=>ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionSchedule" : "ActivityEditionSchedule"),
        Location: (p)=>LocationOrderBy(p ? p + "/Location" : "Location")
    });
function FilterBuilderLocation_ActivityEvent(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        LocationId: new FilterBuilderNumber(mk_prefix('LocationId', prefix)),
        ActivityEventId: new FilterBuilderNumber(mk_prefix('ActivityEventId', prefix)),
        ActivityEvent: new FilterBuilderCollection(mk_prefix('ActivityEvent', prefix), (s)=>FilterBuilderActivityEvent(s)),
        Location: new FilterBuilderCollection(mk_prefix('Location', prefix), (s)=>FilterBuilderLocation(s))
    };
}
const Location_ActivityEventRelationBuilder = {
    ActivityEvent: ()=>mk_rel_query('ActivityEvent', FilterBuilderActivityEvent(), ActivityEventRelationBuilder, ActivityEventParser),
    Location: ()=>mk_rel_query('Location', FilterBuilderLocation(), LocationRelationBuilder, LocationParser)
};
const Location_ActivityEventParser = {
    Id: parseNumber,
    LocationId: parseNumber,
    ActivityEventId: parseNumber,
    ActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Location: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const Location_ActivityEventOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        LocationId: new OrderByProp(p ? p + "/LocationId" : "LocationId"),
        ActivityEventId: new OrderByProp(p ? p + "/ActivityEventId" : "ActivityEventId"),
        ActivityEvent: (p)=>ActivityEventOrderBy(p ? p + "/ActivityEvent" : "ActivityEvent"),
        Location: (p)=>LocationOrderBy(p ? p + "/Location" : "Location")
    });
function FilterBuilderLocation_ArchivedActivityEvent(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        LocationId: new FilterBuilderNumber(mk_prefix('LocationId', prefix)),
        ArchivedActivityEventId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEventId', prefix)),
        ArchivedActivityEvent: new FilterBuilderCollection(mk_prefix('ArchivedActivityEvent', prefix), (s)=>FilterBuilderArchivedActivityEvent(s)),
        Location: new FilterBuilderCollection(mk_prefix('Location', prefix), (s)=>FilterBuilderLocation(s))
    };
}
const Location_ArchivedActivityEventRelationBuilder = {
    ArchivedActivityEvent: ()=>mk_rel_query('ArchivedActivityEvent', FilterBuilderArchivedActivityEvent(), ArchivedActivityEventRelationBuilder, ArchivedActivityEventParser),
    Location: ()=>mk_rel_query('Location', FilterBuilderLocation(), LocationRelationBuilder, LocationParser)
};
const Location_ArchivedActivityEventParser = {
    Id: parseNumber,
    LocationId: parseNumber,
    ArchivedActivityEventId: parseNumber,
    ArchivedActivityEvent: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Location: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const Location_ArchivedActivityEventOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        LocationId: new OrderByProp(p ? p + "/LocationId" : "LocationId"),
        ArchivedActivityEventId: new OrderByProp(p ? p + "/ArchivedActivityEventId" : "ArchivedActivityEventId"),
        ArchivedActivityEvent: (p)=>ArchivedActivityEventOrderBy(p ? p + "/ArchivedActivityEvent" : "ArchivedActivityEvent"),
        Location: (p)=>LocationOrderBy(p ? p + "/Location" : "Location")
    });
function FilterBuilderLoginAttempt(prefix) {
    return {
        IpAddress: new FilterBuilderString(mk_prefix('IpAddress', prefix)),
        Email: new FilterBuilderString(mk_prefix('Email', prefix)),
        Attempts: new FilterBuilderNumber(mk_prefix('Attempts', prefix)),
        LastAttempt: new FilterBuilderDate(mk_prefix('LastAttempt', prefix))
    };
}
const LoginAttemptRelationBuilder = {};
const LoginAttemptParser = {
    IpAddress: parseNullString,
    Email: parseNullString,
    Attempts: parseNumber,
    LastAttempt: parseDate
};
const LoginAttemptOrderBy = (p)=>({
        IpAddress: new OrderByProp(p ? p + "/IpAddress" : "IpAddress"),
        Email: new OrderByProp(p ? p + "/Email" : "Email"),
        Attempts: new OrderByProp(p ? p + "/Attempts" : "Attempts"),
        LastAttempt: new OrderByProp(p ? p + "/LastAttempt" : "LastAttempt")
    });
function FilterBuilderPermanentRedirect(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        OldUrl: new FilterBuilderString(mk_prefix('OldUrl', prefix)),
        NewUrl: new FilterBuilderString(mk_prefix('NewUrl', prefix))
    };
}
const PermanentRedirectRelationBuilder = {};
const PermanentRedirectParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    OldUrl: parseNullString,
    NewUrl: parseNullString
};
const PermanentRedirectOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        OldUrl: new OrderByProp(p ? p + "/OldUrl" : "OldUrl"),
        NewUrl: new OrderByProp(p ? p + "/NewUrl" : "NewUrl")
    });
function FilterBuilderRegion(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
        Title: new FilterBuilderString(mk_prefix('Title', prefix)),
        Slug: new FilterBuilderString(mk_prefix('Slug', prefix)),
        Region_Location: new FilterBuilderCollection(mk_prefix('Region_Location', prefix), (s)=>FilterBuilderRegion_Location(s))
    };
}
const RegionRelationBuilder = {
    Region_Location: ()=>mk_rel_query('Region_Location', FilterBuilderRegion_Location(), Region_LocationRelationBuilder, Region_LocationParser)
};
const RegionParser = {
    Id: parseNumber,
    CreatedDate: parseDate,
    Title: parseNullString,
    Slug: parseNullString,
    Region_Location: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const RegionOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        CreatedDate: new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
        Title: new OrderByProp(p ? p + "/Title" : "Title"),
        Slug: new OrderByProp(p ? p + "/Slug" : "Slug"),
        Region_Location: (p)=>Region_LocationOrderBy(p ? p + "/Region_Location" : "Region_Location")
    });
function FilterBuilderRegion_Location(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        RegionId: new FilterBuilderNumber(mk_prefix('RegionId', prefix)),
        LocationId: new FilterBuilderNumber(mk_prefix('LocationId', prefix)),
        Location: new FilterBuilderCollection(mk_prefix('Location', prefix), (s)=>FilterBuilderLocation(s)),
        Region: new FilterBuilderCollection(mk_prefix('Region', prefix), (s)=>FilterBuilderRegion(s))
    };
}
const Region_LocationRelationBuilder = {
    Location: ()=>mk_rel_query('Location', FilterBuilderLocation(), LocationRelationBuilder, LocationParser),
    Region: ()=>mk_rel_query('Region', FilterBuilderRegion(), RegionRelationBuilder, RegionParser)
};
const Region_LocationParser = {
    Id: parseNumber,
    RegionId: parseNumber,
    LocationId: parseNumber,
    Location: (p)=>parseCollection((x)=>parseEntity(x, p)),
    Region: (p)=>parseCollection((x)=>parseEntity(x, p))
};
const Region_LocationOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        RegionId: new OrderByProp(p ? p + "/RegionId" : "RegionId"),
        LocationId: new OrderByProp(p ? p + "/LocationId" : "LocationId"),
        Location: (p)=>LocationOrderBy(p ? p + "/Location" : "Location"),
        Region: (p)=>RegionOrderBy(p ? p + "/Region" : "Region")
    });
function FilterBuilderSession(prefix) {
    return {
        Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
        LoggedEntityId: new FilterBuilderNumber(mk_prefix('LoggedEntityId', prefix)),
        LoggedEntityName: new FilterBuilderString(mk_prefix('LoggedEntityName', prefix)),
        AdditionalInfo: new FilterBuilderString(mk_prefix('AdditionalInfo', prefix)),
        CookieName: new FilterBuilderString(mk_prefix('CookieName', prefix)),
        Content: new FilterBuilderString(mk_prefix('Content', prefix)),
        CreatedAt: new FilterBuilderDate(mk_prefix('CreatedAt', prefix)),
        LastInteraction: new FilterBuilderDate(mk_prefix('LastInteraction', prefix))
    };
}
const SessionRelationBuilder = {};
const SessionParser = {
    Id: parseNumber,
    LoggedEntityId: parseNullNumber,
    LoggedEntityName: parseNullString,
    AdditionalInfo: parseNullString,
    CookieName: parseNullString,
    Content: parseNullString,
    CreatedAt: parseDate,
    LastInteraction: parseDate
};
const SessionOrderBy = (p)=>({
        Id: new OrderByProp(p ? p + "/Id" : "Id"),
        LoggedEntityId: new OrderByProp(p ? p + "/LoggedEntityId" : "LoggedEntityId"),
        LoggedEntityName: new OrderByProp(p ? p + "/LoggedEntityName" : "LoggedEntityName"),
        AdditionalInfo: new OrderByProp(p ? p + "/AdditionalInfo" : "AdditionalInfo"),
        CookieName: new OrderByProp(p ? p + "/CookieName" : "CookieName"),
        Content: new OrderByProp(p ? p + "/Content" : "Content"),
        CreatedAt: new OrderByProp(p ? p + "/CreatedAt" : "CreatedAt"),
        LastInteraction: new OrderByProp(p ? p + "/LastInteraction" : "LastInteraction")
    });
